import {
    CcLibraryItem,
    CcLibraryItemList,
} from "server/models"
import { TableGroupedIds } from "client/components"

export interface CcLibraryItemProps {
    setId: number
    itemId: number
}

export type CcLibraryItemValidation = { [key in keyof CcLibraryItem]?: string}

export interface CcLibraryItemState {
    itemList: CcLibraryItemList
    itemGroupedIds: TableGroupedIds
    itemView: CcLibraryItem
    itemEdit: CcLibraryItem

    reloadList: boolean
    reloadView: boolean
    reloadEdit: boolean

    // default selected parents for adding/editing
    parentItemId: number
    parentHeadingId: number

    availableParents: CcLibraryItem[]
    availableParentsFiltered: CcLibraryItem[]
    availableParentSearch: string

    menuTargetId: number
    menuTargetElement: any

    confirmDelete: CcLibraryItem
}

export const CC_LIBRARY_ITEM_LIST = "CC_LIBRARY_ITEM_LIST"
export const CC_LIBRARY_ITEM_NESTED = "CC_LIBRARY_ITEM_NESTED"
export const CC_LIBRARY_ITEM_VIEW = "CC_LIBRARY_ITEM_VIEW"
export const CC_LIBRARY_ITEM_EDIT = "CC_LIBRARY_ITEM_EDIT"

export const CC_LIBRARY_ITEM_RELOAD_LIST = "CC_LIBRARY_ITEM_RELOAD_LIST"
export const CC_LIBRARY_ITEM_RELOAD_VIEW = "CC_LIBRARY_ITEM_RELOAD_VIEW"
export const CC_LIBRARY_ITEM_RELOAD_EDIT = "CC_LIBRARY_ITEM_RELOAD_EDIT"

export const CC_LIBRARY_ITEM_PARENTS = "CC_LIBRARY_ITEM_PARENTS"

export const CC_LIBRARY_ITEM_AVAILABLE_PARENTS = "CC_LIBRARY_ITEM_AVAILABLE_PARENTS"
export const CC_LIBRARY_ITEM_AVAILABLE_PARENTS_FILTERED = "CC_LIBRARY_ITEM_AVAILABLE_PARENTS_FILTERED"
export const CC_LIBRARY_ITEM_AVAILABLE_PARENT_SEARCH = "CC_LIBRARY_ITEM_AVAILABLE_PARENT_SEARCH"

export const CC_LIBRARY_ITEM_MENU = "CC_LIBRARY_ITEM_MENU"
export const CC_LIBRARY_ITEM_CONFIRM_DELETE = "CC_LIBRARY_ITEM_CONFIRM_DELETE"
